import script from "./MeetYourReader.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetYourReader.vue?vue&type=script&setup=true&lang=js"

import "./MeetYourReader.vue?vue&type=style&index=0&id=136d9ebd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136d9ebd"]])

export default __exports__